import { createMonitorParameter, loadMonitorParameter, loadMonitorRow } from './widget/monitor-parameter'
import { createDataBlock, updateHeaderTag, loadDataBlock, createMonitorBlock, loadMonitorBlock } from './widget/data-block'
import controlWidget from './widget/control-widget'
import statsWidget from './widget/stats-widget'

import dataBlock from '@/assets/data-block.png'
import dateTime from '@/assets/datetime.png'
import monitorParameter from '@/assets/monitor-parameter.png'
import label from '@/assets/label.png'
import pipeline from '@/assets/pipeline.png'
import StackedLine from '@/assets/StackedLine.png'
import controlWidgetPic from '@/assets/controlWidget.png'

const widget = {
  img: {
    dataBlock,
    dateTime,
    monitorParameter,
    label,
    pipeline,
    StackedLine,
    controlWidgetPic
  },
  monitorParameter: {
    createMonitorParameter,
    loadMonitorParameter,
    loadMonitorRow
  },
  dataBlock: {
    createDataBlock,
    updateHeaderTag,
    loadDataBlock,
    createMonitorBlock,
    loadMonitorBlock
  },
  controlWidget,
  statsWidget
}

export default widget
